<template>
  <div class="drive-breadcrumbs" v-if="breadcrumbs.length > 0">
    <ol class="breadcrumb">
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="crumb.id"
        :class="{ active: index === breadcrumbs.length - 1 }"
      >
        <a
          v-if="index < breadcrumbs.length - 1"
          href="javascript: void(0)"
          @click="$emit('navigate', crumb)"
        >
          <i v-if="index === 0" class="fa fa-home" aria-hidden="true"></i>
          {{ crumb.name }}
        </a>
        <span v-else>
          <i v-if="index === 0" class="fa fa-home" aria-hidden="true"></i>
          {{ crumb.name }}
        </span>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: "DriveBreadcrumbs",
  props: {
    breadcrumbs: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style scoped>
.drive-breadcrumbs {
  margin-bottom: 10px;
}
.drive-breadcrumbs .breadcrumb {
  background: #fff;
  border-radius: 3px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 10px 15px;
  margin-bottom: 0;
}
.drive-breadcrumbs .breadcrumb a {
  color: #337ab7;
  cursor: pointer;
}
.drive-breadcrumbs .breadcrumb a:hover {
  text-decoration: underline;
}
</style>
